import React, { useMemo } from "react";

import MarkdownIt from "markdown-it";
import taskLists from "markdown-it-task-lists";

import { MarkdownContainerProps } from "./MarkdownContainer.types";
import "./MarkdownContainer.scss";

const MarkdownContainer: React.FC<MarkdownContainerProps> = ({ content }) => {
  const md = useMemo(() => new MarkdownIt(), []);
  const mdContent = useMemo(() => {
    const parser = md.use(taskLists, {
      enabled: true,
      label: true,
      labelAfter: true,
    });
    return parser.render(content || "");
  }, [content, md, taskLists]);

  return (
    <div
      data-testid="MarkdownContainer"
      className="mp-templates-markdowncontainer--main"
      dangerouslySetInnerHTML={{ __html: mdContent }}
    />
  );
};

export default MarkdownContainer;
